module.exports = __webpack_public_path__ + "static/media/flag-it.33eee6fa.webp";